//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import { useState } from 'react';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';

import * as choiceApi from '../../api/choice';

export function ChangePassword() {
    const [origPass, setOrigPass] = useState("");
    const [newPass1, setNewPass1] = useState("");
    const [newPass2, setNewPass2] = useState("");
    const [saving, setSaving] = useState(false);
    const [msg, setMsg] = useState("");
    const [variant, setVariant] = useState("");

    const onSubmit = async (e) => {
        e.preventDefault();

        if (newPass1 === newPass2) {
            try {
                setSaving(true);
                const info = await choiceApi.changePassword(origPass, newPass1);
                setSaving(false);
                setMsg(info.message);
                setVariant("success")
            }
            catch (err) {
                console.log(err);
                setMsg(err?.response?.data?.message)
                setVariant("danger")
            }
            setOrigPass("");
            setNewPass1("");
            setNewPass2("");
        }
        else {
            setMsg("New passwords do not match")
        }
    }


    const alert = msg ? <Alert className="mt-3" variant={variant}>{msg}</Alert> : null;

    return (
        <div>
            <h1>Change Password</h1>

            {alert}
            <Form onSubmit={onSubmit}>

                <div className='mt-3'>Current Password</div>
                <FormControl type="password" value={origPass} onChange={(e) => setOrigPass(e.target.value)} />

                <div className='mt-3'>New Password</div>
                <FormControl type="password" value={newPass1} onChange={(e) => setNewPass1(e.target.value)} />

                <div className='mt-3'>Confirm New Password</div>
                <FormControl type="password" value={newPass2} onChange={(e) => setNewPass2(e.target.value)} />

                <div className='mt-4'>
                    <Button className='w-100' type='submit' disabled={saving}>Save</Button>
                </div>
            </Form>
        </div>

    );
}
